/**
 * The Geographies & Addresses route (FSD 1.2.8, SCR-1.2.8-GEO).
 *
 * The router spread and the nav entry belong to the integration step, which
 * owns `web/src/router/**` and `web/src/nav/**`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { GEOGRAPHY_PERMISSIONS } from '@/modules/enterprise/geographies/permissions'

export const GEOGRAPHIES_PATH = '/enterprise/geographies'

export function geographiesRoute(): string {
  return GEOGRAPHIES_PATH
}

export const ENTERPRISE_GEOGRAPHY_ROUTES: RouteRecordRaw[] = [
  {
    path: GEOGRAPHIES_PATH,
    name: 'enterprise-geographies',
    component: () => import('@/modules/enterprise/geographies/GeographiesView.vue'),
    meta: {
      titleKey: 'enterprise.geographies.routeTitles.geographies',
      permission: GEOGRAPHY_PERMISSIONS.read,
    },
  },
]
